import { MDTypography } from "../../../Component/Common/Components/MDTypography"
import { SampleMethodologiesPage } from "../SampleMethodologies/SampleMethodologies"

export const SampleMethodologyHomepage = () => {
    return (
        <>
            <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                Manage Sample Methodologies
            </MDTypography>
            <SampleMethodologiesPage />
        </>
    )
}